/*******************************************************************************
 * Copyright     : Copyright (c)  2025 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";

// @Components
import ActiveConnections from './ActiveConnections/ActiveConnections';
import GatewayConnectivity from "./GatewayConnectivity/GatewayConnectivity";
import ConnectLinkedDevices from "./ConnectLinkedDevices/ConnectLinkedDevice";

//@Models
import { ConnectTabProps } from "../../models/remoteConnect";
import { DataCard } from "../../reusablecomponents/datacard";
import { LOCALE_CONST } from "../../utils/constants";
import { useTranslation } from "react-i18next";

const RemoteConnect: React.FC<ConnectTabProps> = ({ hrefUrl, remoteAgentStatus, enableBacsRemoteConnect ,gatewayType,disableRemoteConnectForEbi}) => {
  const { t } = useTranslation();
  const getColorClsName = (status: string = "") => {
    if (status === "Disconnected") {
      return "gray";
    } else {
      return "green";
    }
  };

  const getStatusValue = (status: string = "") => {
    if (status === "Disconnected") {
      return "Disconnected";
    } else {
      return "Connected";
    }
  };
  return (
    <>
      {gatewayType === "EBI-Platform" ? (
        <GatewayConnectivity hrefUrl={hrefUrl} gatewayType={gatewayType} />
      ) : gatewayType === "alerton-compass" && enableBacsRemoteConnect ? (
        <div className="connect-tab-container">
          <GatewayConnectivity hrefUrl={hrefUrl} gatewayType={gatewayType} />
          <ConnectLinkedDevices />
          <ActiveConnections />
        </div>
      ) : (
        <DataCard
          title={t(LOCALE_CONST.remoteConnection)}
          deviceData={[
            { label: t(LOCALE_CONST.remoteUrl), hrefUrl },
            {
              label: "REMOTE AGENT HEALTH",
              uiValue: remoteAgentStatus,
              hideRow: gatewayType !== "honeywell-bms-gateway",
            },
          ]}
          getColorClsName={getColorClsName}
          getStatusValue={getStatusValue}
        />
      )}
    </>
  );
};

export default RemoteConnect;